// NOTE(DS migration, GOTU-3282): no primitives to migrate in this file — the title/description
// typography is rendered INSIDE EmptyScreen (kept commonComponent, legacy Text 22/16px). Raw
// <ul>/<li>/<b> fragments passed as `description` inherit EmptyScreen's text styling; wrapping
// them in DS Typography would double-wrap and fight it. Migrate together with EmptyScreen.
import { motion } from 'framer-motion';
import { EmptyScreen } from '~/commonComponents/EmptyScreen/EmptyScreen';
import { EmptyRecommendedProsIcon } from '~/images/emptyScreenIcons';

export const EmptyRecommendedPros = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    style={{
      maxWidth: '827px',
      height: 600,
      display: 'flex',
      flexDirection: 'column',
      gap: 32,
      marginLeft: 'auto',
      marginRight: 'auto',
      // LEGACY-HACK (cleanup candidate): pulls the empty screen up to undo container spacing.
      marginTop: -20,
    }}
  >
    <EmptyScreen
      Icon={EmptyRecommendedProsIcon}
      title="No new professionals at this time!"
      width={540}
      description="We are searching for professionals who meet the “New to You” criteria in your area. Come
          back soon to see who we find!"
      descriptionStyle={{
        textAlign: 'center',
      }}
    />
  </motion.div>
);
